<div class="admin-container container my-5">
  <div class="card shadow-sm p-5">
    <h1 class="text-center mb-4 text-dark">Panel de Administración</h1>
    <p class="text-center text-muted fs-5 mb-5">
      Bienvenido, administrador. Selecciona una opción para continuar.
    </p>

    <!-- Menú principal -->
    <div class="d-flex flex-wrap gap-4 justify-content-center mb-5">
      <button class="btn btn-menu" (click)="opcionPiensos()">Piensos</button>
      <button class="btn btn-menu" (click)="opcionCorderos()">Corderos</button>
    </div>

    <!-- Submenú dinámico -->
    <div *ngIf="subOpciones.length > 0" class="text-center">
      <h3 class="mb-3">{{ tituloOpcion }}</h3>
      <p class="text-muted mb-4">{{ descripcionOpcion }}</p>

      <div class="d-flex flex-wrap gap-3 justify-content-center">
        <button
          class="btn btn-submenu"
          *ngFor="let sub of subOpciones"
          (click)="ejecutarAccion(sub.accion)"
        >
          {{ sub.titulo }}
        </button>
      </div>
    </div>
  </div>
</div>
